export function toTop() {

    let goTopBtn = document.createElement('div');
        goTopBtn.classList.add('to-top');
        goTopBtn.style.opacity = 0;

    goTopBtn.addEventListener('click', function() {

        let startPos = document.documentElement.scrollTop || document.body.scrollTop,
            finishPos = 0,
            diffPos = finishPos - startPos,
            duration = 400,
            startTime = new Date().getTime(),
            finishTime = startTime + duration;

        let anim = setInterval( () => {
            let currentTime = new Date().getTime(),
                newPos;

            if (currentTime >= finishTime) {
                newPos = finishPos;
                clearInterval(anim);
            } else {
                let diffTime = finishTime - currentTime,
                    diffPrc =  diffTime / duration;
                newPos = finishPos - (diffPos * diffPrc);
            }

            window.scrollTo(0, newPos);
        },10);
    });

    window.addEventListener('scroll', function() {
        let currentPos = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentPos >= 100) {
            goTopBtn.style.opacity = 1;
        } else {
            goTopBtn.style.opacity = 0;
        }
    })

    document.body.appendChild(goTopBtn);

}